<template>
  <div>

    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>调查问卷</el-breadcrumb-item>
    <el-breadcrumb-item>查看调查问卷</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>

<el-table
    ref="multipleTable"
    :data="cloudFileList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      label="问卷标题"
      width="120"
      :show-overflow-tooltip="true"
      prop="survey_name">
      
    </el-table-column>
    <el-table-column
      label="创建时间"
      width="120"
      :show-overflow-tooltip="true"
      prop="create_date">
      
    </el-table-column>
    <el-table-column
      label="状态"
      width="120"
      :show-overflow-tooltip="true"
      :formatter="formatter_survey_state"
      prop="survey_state">
      
    </el-table-column>
 <el-table-column
      label="操作"
      width="150">
        <template slot-scope="scope" >
   <el-button type="info" id="equSN" @click="getCope(scope.row)" >点击做题</el-button>
      </template>
    </el-table-column>

  </el-table>



 </el-card>
  <!-- <el-dialog
  :visible.sync="dialogVisible"
  width="80%"
  destroy-on-close
  >
  <iframe :src="htmlUrl"  id="outerHTML" width='100%'  name="ifd"  ref="iframe2"   style="min-height:800px" scrolling="no" frameborder="0"></iframe>

  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog> -->



  </div>
</template>

<script>


export default {
    created(){
    this.getQuestionnaireList()
  },
data(){
    return{
      dialogVisible:false,
      htmlUrl:'',
      teacherid:'',
      studentid:'',
      cloudFileList:[],
        questionnaireList:null,
    }
},
methods:{
    getQuestionnaireList(){
        let student=JSON.parse(localStorage.getItem("user")).userid
        let teacher=JSON.parse(localStorage.getItem("user")).teacherid
         this.teacherid=teacher
         this.studentid=student
        let subData={
            'userFromId':teacher,
            'userFromType':'1'
        }
        this.axios.post("/SurveyDetail/getSurveyDetailList", subData)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.cloudFileList=resp.data.result
               console.log(resp.data.result)
          } else {
            this.$message.error("发生过错误");
            this.loading=false
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });

    },formatter_survey_state(row, column){
      if(row.survey_state==0){
        return "设计状态";
      }else  if(row.survey_state==1){
        return "执行中";
      }else  if(row.survey_state==2){
        return "结束";
      }else{
        return "未知状态"
      }
      },
    getCope(data){
      let test=this.$DWSurveyHtmlUrl+'/static/diaowen/answer-p.html?sid='+data.sid+'&publisher='+this.teacherid+'&respondent='+this.studentid
      this.htmlUrl=test
      window.open(test)
      // this.dialogVisible=true
       console.log('dizhi',test)
    }
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/student/AnswerQuestion.vue